import { useEffect, useState } from 'react';
import { serviceService } from '../services/serviceService';
import type { Service } from '../types/service.types';

export function useService(id: string | undefined) {
  const [data, setData] = useState<Service | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!id) {
      setIsLoading(false);
      return;
    }
    let cancelled = false;
    setIsLoading(true);
    setError(null);

    serviceService
      .getById(id)
      .then((s) => {
        if (!cancelled) setData(s);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err : new Error(String(err)));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return { data, isLoading, error };
}
